"use client";

import { useMemo } from "react";
import { usePathname } from "next/navigation";
import { setPopupId } from "@/redux/features/ShopSlice";
import { useAppDispatch, useAppSelector } from "@/redux/hook";
import { setCartGlobalErrors } from "@/redux/features/CartSlice";

import Cart from "@/common/constants/cart";
import { Errors } from "@/common/constants/errors";
import Website from "@/common/constants/webstite";

import Popup from "@/components/Popup";
import Button from "@/components/ui/Button";
import LinkElement from "@/components/LinkElement";
import PopupErrorIcon from "@/components/icons/PopupErrorIcon";
import useTranslationApi from "@/lib/hooks/useTranslationApi";
import Helper from "@/utils/helper";

type Props = {
	handleOnClose?: () => void;
};

const translate = {
	go_to_cart: "go_to_cart",
	close: "close",
	cart_error_item_quantity_invalid: "cart_error_item_quantity_invalid",
	cart_error_promotion_invalid: "cart_error_promotion_invalid",
	cart_error_promotion_quantity_invalid:
		"cart_error_promotion_quantity_invalid",
	cart_error_promotion_time_invalid: "cart_error_promotion_time_invalid",
	cart_error_promotion_subtotal_invalid:
		"cart_error_promotion_subtotal_invalid",
	cart_error_store_warehouse_invalid: "cart_error_store_warehouse_invalid",
	cart_error_id_warehouse_invalid: "cart_error_id_warehouse_invalid",
	cart_error_product_id_invalid: "cart_error_product_id_invalid",
	cart_error_warehouse_id_invalid: "cart_error_warehouse_id_invalid",
	reload: "reload",
	cart_error_item_quantity_limit_sale_1:
		"cart_error_item_quantity_limit_sale_1",
	cart_error_item_quantity_over_1: "cart_error_item_quantity_over_1",
	product: "product",
	cart_error_item_quantity_over_2: "cart_error_item_quantity_over_2",
	notice: "notice",
	cart_data_not_found: "cart_data_not_found",
};

const CartErrorPopup = ({ handleOnClose }: Props) => {
	const { t } = useTranslationApi(Object.keys(translate));
	const pathname = usePathname();
	const dispatch = useAppDispatch();

	const errorCartGlobal = useAppSelector(
		(state) => state.CartReducer.cartGlobalErrors
	);

	const onClose = () => {
		if (!pathname.includes("/checkouts") && !pathname.includes("/cart")) {
			if (errorCartGlobal.includes("error_item_quantity_invalid")) {
				// location.reload();
			}
		} else {
			// router.back();
		}
		handleOnClose && handleOnClose();
		dispatch(setPopupId(""));
		dispatch(setCartGlobalErrors([]));
	};

	const errorDescription = useMemo(() => {
		const errorFirst = errorCartGlobal.length > 0 ? errorCartGlobal[0] : "";
		const isShowNoti = ![
			Errors.error_item_quantity_limit_sale,
			Errors.error_warehouse_id_invalid,
		].includes(errorFirst);
		let result = <span></span>;
		switch (errorFirst) {
			case Errors.error_item_quantity_limit_sale:
				result = (
					<>
						<p>
							<span>
								{t(translate.cart_error_item_quantity_limit_sale_1)}{" "}
								<strong>hotline</strong>{" "}
								<a className="text-sm text-blue-500" href="tel:+1900 0129">
									1900 0129
								</a>
								.
							</span>
						</p>
						<div className="flex items-center justify-center gap-[10px] mt-2">
							<Button
								mode="dark-outline"
								label={t("close")}
								className="w-[127px] h-[35px] px-[14px] py-2"
								onClick={onClose}
							/>
							<LinkElement
								href={Website.LINK.PAGE.CART}
								onClick={onClose}
								className="w-[127px] h-[35px] px-[14px] py-2 rounded bg-red-500 text-white flex items-center justify-center text-sm">
								{t("go_to_cart")}
							</LinkElement>
						</div>
					</>
				);
				break;
			case Errors.error_item_quantity_invalid:
				result = (
					<span>
						{/* Số lượng tồn kho hiện tại chưa thỏa mãn yêu cầu. */}
						{t(translate.cart_error_item_quantity_invalid)}
					</span>
				);
				break;
			case Errors.error_item_quantity_over:
				result = (
					<span>
						{t(translate.cart_error_item_quantity_over_1)}{" "}
						<span className="font-bold">10</span> {t(translate.product)}.{" "}
						{t(translate.cart_error_item_quantity_over_2)}{" "}
						<span className="font-bold">Hotline</span> nếu như mua nhiều hơn{" "}
						<span className="font-bold">10</span> {t(translate.product)}.
					</span>
				);
				break;
			case Cart.ERROR.error_promotion_invalid:
				result = (
					<span>
						{/* Chương trình khuyến mãi không hợp lệ */}
						{t(translate.cart_error_promotion_invalid)}
					</span>
				);
				break;
			case Cart.ERROR.error_promotion_quantity_invalid:
				result = (
					<span>
						{/* Chương trình khuyến mãi không hợp lệ */}
						{t(translate.cart_error_promotion_quantity_invalid)}
					</span>
				);
				break;
			case Cart.ERROR.error_promotion_time_invalid:
				result = (
					<span>
						{/* thời gian Chương trình khuyến mãi không hợp lệ */}
						{t(translate.cart_error_promotion_time_invalid)}
					</span>
				);
				break;
			case Cart.ERROR.error_promotion_subtotal_invalid:
				result = (
					<span>
						{/* số tiền chưa thõa mãn yêu cầu của chương trình khuyến mãi */}
						{t(translate.cart_error_promotion_subtotal_invalid)}
					</span>
				);
				break;

			case Errors.error_store_warehouse_invalid:
				result = (
					<span>
						{/* Hệ thống shop có cập nhập mới bạn vui lòng thao tác lại nhé ! */}
						{t(translate.cart_error_store_warehouse_invalid)}
					</span>
				);
				break;
			case Errors.error_id_warehouse_invalid:
				result = (
					<span>
						{/* Hệ thống shop có cập nhập mới bạn vui lòng thao tác lại nhé ! */}
						{t(translate.cart_error_id_warehouse_invalid)}
					</span>
				);
				break;
			case Errors.error_product_id_invalid:
				result = (
					<span>
						{/* Sản phẩm hiện không còn tồn tại */}
						{t(translate.cart_error_product_id_invalid)}
					</span>
				);
				break;
			case Errors.error_warehouse_id_invalid:
				result = (
					<>
						<p className="mb-2 text-gray-500">
							{/* Shop có cập nhập mới ! Bạn vui lòng tải lại trang. */}
							{t(translate.cart_error_warehouse_id_invalid)}
						</p>
						{/* <div className="flex items-center justify-center gap-[10px] mt-2">
							<Button
								mode="dark-outline"
								label={t(translate.reload)}
								className="w-[127px] h-[35px] px-[14px] py-2"
								onClick={async () => {
									await handleRefeshDataCart().then(() => {
										window.location.reload();
									});
								}}
							/>
						</div> */}
					</>
				);
				break;
			default:
				result = (
					<span>
						{Helper.isDev()
							? t(errorFirst)
							: "Website tạm thời bị gián đoạn. Vui lòng thử lại sau"}
					</span>
				);
		}

		return (
			<>
				{isShowNoti && <p className="font-bold">{t(translate.notice)}</p>}
				{result}
			</>
		);
	}, [errorCartGlobal]);

	return (
		<div className="block w-full bg-transparent">
			<Popup
				classNameCloseButton="absolute right-4 top-4"
				classNameContent={"rounded-[8px] bg-white w-[360px] h-fit px-4 py-6"}
				popupId={Cart.POPUP.cart_error_popup}
				handleOnClose={onClose}
				centered={true}>
				<div className="flex flex-col gap-2 justify-center items-center text-base leading-[1.6] text-gray-500 text-center">
					<PopupErrorIcon />

					<>
						<p>{errorDescription}</p>
					</>
				</div>
			</Popup>
		</div>
	);
};

export default CartErrorPopup;
